<div class="main user-profile">
    <div class="main-title">
        <h1>Profile</h1>
        <p>Edit your farm Information</p>
    </div>
    <h2>Account Information</h2>
    <app-update-profile></app-update-profile>
</div>
<div class="main farm-dashboard">
    <h1 class="main-title">You have {{ farms.length }} farms available</h1>
    <div class="edit-farm text-right"><button (click)="editFarm()" class="btn"><i class="fas fa-pencil-alt"></i> Edit Farm</button></div>
    <div class="tab-container">
        <!-- Tabs -->
        <div class="tabs">
            <button *ngFor="let farm of farms" [ngClass]="{ 'active-tab': farm.id === selectedFarmId }"
                (click)="selectFarm(farm.id)">
                {{ farm.name }}
            </button>
        </div>

        <!-- Farm Content -->
        <div *ngFor="let farm of farms">
            <div *ngIf="farm.id === selectedFarmId">
                
                <div class="farmhouse-list">
                    <div *ngFor="let house of farm.farmHouses" class="house-content">
                        <div class="house-top"></div>
                        <div class="house">
                            <div class="house-header">
                                <h4>{{ house.name }}</h4>
                                <p>{{house.length}}L x {{house.width}} W</p>
                            </div>
                            <div *ngFor="let partition of house.farmHousePartitions" class="partition" >
                                <div class="partition-capacityStatus" [ngClass]="{ 'partitionavailable': !partition.capacityStatus, 'partitionfull': partition.capacityStatus }">
                                    <div class="partition-top">
                                        <h3>{{ partition.name }}</h3>
                                        <p>Length: {{ partition.length }}m</p>
                                    </div>
                                    <button class="add-config-sensor" pTooltip="Add Sensor detail" (click)="openAddSensorPopup(farm.id, house.id, partition.id)">
                                        <i class="fas fa-cog"></i>
                                    </button>
                                    <div class="row partition-botton">
                                        <div [ngClass]="{ 'col-md-7': !partition.capacityStatus, 'col-md-8': partition.capacityStatus }">
                                            <p><label>Capacity</label>: {{ partition.capacity }}</p>
                                        </div>
                                        <div [ngClass]="{ 'col-md-5': !partition.capacityStatus, 'col-md-4': partition.capacityStatus }">
                                            <span><i class="fas fa-circle"></i>
                                            {{ !partition.capacityStatus ? 'Available' : 'Busy' }}
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom-edit-div text-right">
                                <h6>Total Partitions:{{house.farmHousePartitions.length}}</h6>

                            </div>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<p-dialog [(visible)]="displayfarm" modal="true" [style]="{width: '1200px'}" [closable]="false">
    <!-- <div class="text-left" (click)="closeDialog()"> <span class="fas fa-chevron-left"></span> Back</div> -->
    <ng-template pTemplate="content">
        <app-farm (close)="onCloseFarmDialog()"></app-farm>
    </ng-template>
</p-dialog>
<!-- Add Sensor Popup -->
<p-dialog [(visible)]="displaySensorPopup" modal="true" [style]="{width: '500px'}" (onHide)="closePopup()">

    <ng-template pTemplate="header">
        <h3>Farm Sensor List</h3>
    </ng-template>
    <table class="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Device Id</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sensor of farmHouseSensorsList; index as i">
            <td>{{ i + 1 }}</td>
            <td>{{ sensor.sensorName }}</td>
            <td>{{ sensor.deviceId }}</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="!farmHouseSensorsList || farmHouseSensorsList.length === 0" class="text-center mt-3">
        <p>No sensors found</p>
      </div>
    <ng-template pTemplate="content">
        <!-- <p>Farm ID: {{ currentFarmId }}</p>
        <p>FarmHouse ID: {{ currentFarmHouseId }}</p>
        <p>Partition ID: {{ currentPartitionId }}</p> -->

        <div *ngFor="let sensor of sensors; let i = index" class="sensor-dropdown">
            <p-dropdown 
                [options]="sensorsList" 
                [(ngModel)]="sensor.sensorId" 
                placeholder="Select Sensor"
                optionLabel="name"
                optionValue="id"
                appendTo="body"
                class = "w-100"
                [ngModelOptions]="{standalone: true}">
            </p-dropdown>
            <div class="text-right">
                <button class="btn btn-remove-sensors mt-2" (click)="removeSensor(i)" *ngIf="sensors.length > 1">Remove</button>
            </div>
        </div>
        <div class="text-right">
            <button class="btn btn-add-sensor" (click)="addSensor()">+ Add Another Sensor</button>
        </div>        
    </ng-template>
    
    <ng-template pTemplate="footer">
        <button type="button" class="btn btn-secondary mr-2" (click)="closePopup()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveSensors()">Save</button>
    </ng-template>
</p-dialog>